import { transition } from '@helpers/animate';
import { imageCoverContainer, imageWrapperPreserveRatio } from '@helpers/aspectRatio';
import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import { Device, from } from '@helpers/media';
import { h5, paragraphRegular } from '@helpers/typography';
import ButtonStyles from '@stories/Components/Buttons/Button/Button.styles';
import { cardWidth } from '@stories/Components/CardGrid/CardGrid.styles';
import { ContentType } from '@stories/Components/Misc/SectionWrapper/SectionWrapper';
import styled from 'styled-components';
const Container = styled.a `
  ${cardWidth};

  --contentColour: ${brand.blue.navy};
  --bgColour: ${brand.global.beige};

  ${transition('transform, box-shadow', 0.25)};

  display: flex;
  flex-direction: column;
  border-radius: 20px 20px 20px 0;
  color: var(--contentColour);
  background: var(--bgColour);
  overflow: hidden;
  text-decoration: none;

  &[data-theme=${ContentType.Default}][data-has-media='false'] {
    --bgColour: ${brand.green.light};
  }

  &[data-theme=${ContentType.Savings}][data-has-media='false'] {
    --bgColour: ${brand.blue.light};
  }

  &:focus {
    outline: none;
  }

  &:focus-visible {
    outline: auto;
    outline-offset: 2px;
    outline-width: 2px;
    outline-style: solid;
    outline-color: ${brand.global.black};
  }

  @media ${from(Device.Tablet)} {
    max-width: var(--maxWidth);
  }
`;
const ImageContainer = styled.div `
  ${imageWrapperPreserveRatio(417, 240)};

  --imageBgColor: ${brand.blue.default};
  --iconColor: ${brand.global.white};

  display: grid;
  place-content: center;
  position: relative;
  background: var(--imageBgColor);

  &[data-bg-color='transparent'] {
    --imageBgColor: transparent;
  }

  &[data-bg-color='mortgages'] {
    --imageBgColor: ${brand.green.default};
  }

  &[data-bg-color='intermediaries'] {
    --imageBgColor: ${brand.green.light};
    --iconColor: ${brand.blue.navy};
  }

  svg {
    width: ${fluid(80, 200)};
    height: ${fluid(80, 200)};
    color: var(--iconColor);
  }

  @media ${from(Device.TabletLarge)} {
    ${Container}[data-is-pair='true'] & {
      aspect-ratio: 853 / 171;
    }

    ${Container}[data-is-pair='true']:has(img) & {
      aspect-ratio: 853 / 290;
    }
  }
`;
const Image = styled.img `
  ${transition('transform')};
  ${imageCoverContainer()};

  ${Container}:hover &,
  ${Container}:focus-visible & {
    transform: scale(1.1);
  }
`;
const ContentWrapper = styled.div `
  display: flex;
  flex-direction: column;
  padding: ${fluid(16, 24)} 16px 51px;
  margin-top: auto;
`;
const ContentArea = styled.div `
  flex: 1 0 auto;
`;
const Heading = styled.h4 `
  ${h5};

  margin-bottom: 8px;
`;
const Description = styled.p `
  ${paragraphRegular};
  margin: 0;
`;
const FakeButtonWrapper = styled.div `
  position: absolute;
  right: 16px;
  bottom: 16px;

  ${ButtonStyles.Container} {
    --buttonHeight: 27px;
  }

  ${ButtonStyles.IconWrapper} {
    --iconHeight: 16px;
  }
`;
const SignpostCardStyles = {
    Container,
    ContentArea,
    ImageContainer,
    Image,
    ContentWrapper,
    Heading,
    Description,
    FakeButtonWrapper,
};
export default SignpostCardStyles;
